import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { CloseCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { StatsCard, Header, LeaveInfo, DashboardFilter } from 'components/pages/leave-management';
import Addleave from 'assets/add-leave-fab-button.svg';
import { theme } from 'styles/theme';
import { Box, Flex, Text, Image, Button } from 'atoms';
import { setSelectedFilter, setFilterDates, setFilterApply } from 'store/leaveSlice';

const Container = styled(Flex)`
	flex-direction: column;
`;

const AddLeave = styled(Flex)`
	position: absolute;
	bottom: 20px;
	right: 8px;
	flex-direction: column;
	align-items: center;
	width: 68px;
	height: 68px;
	padding: 5px;
	border-radius: 40px;
	background-color: ${(props) => props.theme.colors.CelticBlue};
	color: ${(props) => props.theme.colors.white};
	img {
		width: 25px;
		height: 25px;
		margin-top: 6px;
		margin-left: 6px;
		margin-bottom: 5px;
	}
`;

const FilterCloseBtn = styled(Button)`
	justify-content: center;
	align-items: center;
	width: 30px;
	height: 30px;
	padding: 0;
	margin-right: 15px;
	border-radius: 2px;
	border: 1px solid transparent;
	background: transparent;
	text-align: center;
	cursor: pointer;
`;

export default function LeaveManagement() {
	const history = useHistory();
	const dispatch = useDispatch();
	const { selectedFilter = '' } = useSelector((state) => state.leave);

	function filterClose() {
		dispatch(setFilterDates([]));
		dispatch(setSelectedFilter(''));
		dispatch(setFilterApply(false));
	}

	return (
		<Container>
			<Header />
			<StatsCard />
			<Flex
				mt="30px"
				mb="5px"
				justifyContent="space-between"
				alignItems="center"
				p="3px 10px"
			>
				<Flex justifyContent="center" alignItems="center">
					<Text fontSize="12px" p="10px 20px" mx="10px" bg={theme.colors.white}>
						1/30
					</Text>
					<Text fontSize="12px">Leave History</Text>
				</Flex>
				<Flex>
					{selectedFilter && (
						<FilterCloseBtn onClick={() => filterClose()}>
							<CloseCircleOutlined style={{ color: 'red', fontSize: '15px' }} />
						</FilterCloseBtn>
					)}
					<Box bg={theme.colors.white} mr="10px" p="5px" cursor="pointer">
						<DashboardFilter />
					</Box>
				</Flex>
			</Flex>
			<LeaveInfo />
			<AddLeave onClick={() => history.push('/add-leave')}>
				<Image src={Addleave} alt="AddLeave" />
				<Text fontSize="10px" fontWeight="300">
					Add leave
				</Text>
			</AddLeave>
		</Container>
	);
}
